export enum UserNavigationEventTypes {
  USER_NAVIGATION_REQUEST = 'USER_NAVIGATION_REQUEST',
}
